import axios from 'axios';
import { toast } from 'sonner';
import { getApiUrl } from '../../utils/api';

export const API = getApiUrl();
export const W = { withCredentials: true };
const CLE = 'q35-file-attente';

export const err = (e, d) => { const x = e?.response?.data?.detail; toast.error(typeof x === 'string' ? x : d); };
export const money = (v, c = 'MAD') => (v == null ? 'à compléter' : `${Number(v).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${c}`);
export const num = (v) => (v == null ? '' : Number(v).toLocaleString('fr-FR', { maximumFractionDigits: 3 }));
const uuid = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`);

export const enAttente = () => { try { return JSON.parse(localStorage.getItem(CLE) || '[]'); } catch { return []; } };
const garder = (l) => { localStorage.setItem(CLE, JSON.stringify(l)); window.dispatchEvent(new Event('q35-attente')); };

/* T1 · chaque saisie porte un client_uuid ; sans réseau, elle reste sur l'appareil et part au retour, dans l'ordre. */
export const envoyer = async (url, body, label) => {
  const b = { ...body, client_uuid: body.client_uuid || uuid() };
  try {
    return (await axios.post(`${API}${url}`, b, W)).data;
  } catch (e) {
    if (!e.response) { garder([...enAttente(), { url, body: b, label, le: new Date().toISOString() }]); toast('Pas de réseau · gardé sur votre téléphone, envoyé au retour du réseau'); return { enAttente: true }; }
    throw e;
  }
};

export const vider = async () => {
  const l = enAttente();
  const reste = [];
  for (const x of l) {
    try { await axios.post(`${API}${x.url}`, x.body, W); } catch (e) { if (!e.response) reste.push(x); }
  }
  garder(reste);
  return l.length - reste.length;
};

if (typeof window !== 'undefined') window.addEventListener('online', () => { if (enAttente().length) vider(); });
